import { Phone, Clock3, ShieldCheck } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import InquiryForm from "@/components/InquiryForm";
import { CONTACT } from "@/lib/site";

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact — Riverstone Partners"
        description="Tell us what you're working toward. Request a conversation with Riverstone Partners about marketing, wellness, medical billing, shipping, or emerging opportunities."
        path="/contact"
      />

      <section className="border-b border-charcoal/10 bg-sage/50 py-16 md:py-24">
        <div className="shell max-w-3xl">
          <p className="eyebrow text-forest">Contact</p>
          <h1 className="mt-5 font-serif text-4xl font-light leading-[1.1] tracking-tight text-navy sm:text-5xl" data-testid="contact-title">
            Tell us what you’re working toward.
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-charcoal/80">
            We’ll help you explore the solutions that may fit. Share a few details and
            we’ll reach out to arrange a conversation—there’s no obligation, and nothing
            to prepare.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="shell grid gap-14 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
          <Reveal>
            <div className="space-y-8">
              <div>
                <p className="eyebrow text-river">Prefer to talk?</p>
                <a
                  href={CONTACT.phoneHref}
                  data-testid="contact-phone-link"
                  className="mt-3 inline-flex min-h-[44px] items-center gap-3 font-serif text-2xl text-navy transition-colors hover:text-forest"
                >
                  <Phone className="h-5 w-5 text-river" />
                  {CONTACT.phone}
                </a>
              </div>
              <div className="border-t border-charcoal/10 pt-8">
                <p className="flex items-start gap-3 text-sm leading-relaxed text-charcoal/70">
                  <Clock3 className="mt-0.5 h-4 w-4 shrink-0 text-river" />
                  We’ll respond personally—usually within one or two business days.
                </p>
              </div>
              <div className="border-t border-charcoal/10 pt-8">
                <p className="flex items-start gap-3 text-sm leading-relaxed text-charcoal/70">
                  <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-river" />
                  Your information is used only to respond to your inquiry. Please don’t
                  include patient records, sensitive medical details, or financial
                  account information.
                </p>
              </div>
              <div className="border-t border-charcoal/10 pt-8">
                <p className="text-sm leading-relaxed text-charcoal/70">
                  Interested in the affiliate opportunity instead? Visit{" "}
                  <a href="/become-a-partner" className="font-medium text-forest underline-offset-4 hover:underline">
                    Become a Partner
                  </a>
                  — partner inquiries are handled separately.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="border border-charcoal/10 bg-white p-7 md:p-10">
              <InquiryForm variant="business" title="Request a Conversation" />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
